// extracted by mini-css-extract-plugin
module.exports = {"loader":"VideoPreview_loader__IedMf"};